import { computed } from '@ember/object';
import CommonActualFilterAmplitude from '../common/actual-filter-amplitude';
import * as Complex from '../../../process-data/complex';

export default CommonActualFilterAmplitude.extend({
  r1: null,
  c1: null,
  complexAlphaPlus: computed('r1', 'c1', 'sImaginary', function () {
    var sImaginary = this.sImaginary;

    var r1 = this.r1;
    var c1 = this.c1;

    var result = Complex.createComplex(0, r1 * c1 * sImaginary).divide(Complex.createComplex(1, r1 * c1 * sImaginary));
    return result;
  }),
});
